function initStepsAnimation()
{
    var nextButtons = document.querySelectorAll(".next-step");
	var select_collections = [];
	var select_type = [];
	var select_vendor = [];

    nextButtons.forEach((nextButton) =>
    {
        nextButton.addEventListener("click", function(e)
        {
              console.log( "quiz next ");
          
			// animate number
			var current_step = document.querySelector(".welleasy_steps .active");
			nextButton.classList.add( "hidden" );
			if(current_step)
			{
				current_step.classList.remove('active');
				current_step.classList.add('completed');
			}

			var next_step = document.querySelector(".step_" + nextButton.dataset.next_step_number);

			if (next_step) 
			{				
				next_step.classList.add('active');
			}

         	if( nextButton.dataset.next_step == "welleasy_email_section" )
			{
				var parentSection = SearchParentsFor( nextButton, "quiz_questions" );
				parentSection.classList.add( "shrink" );
			}
			else
			{	
				var parentSection = SearchParentsFor( nextButton, "quetion_area" );
				parentSection.classList.add( "shrink" );	
			}
			
			GetWEQuizRedirectURL();

			var nextSection = document.querySelector( "." + nextButton.dataset.next_step );
			nextSection.classList.remove( "hidden" );

				var quetion_area = SearchParentsFor( nextButton, "quetion_area" );

				var checked_AllInputs	= quetion_area.querySelectorAll( ".single_option input[type='checkbox']:checked" );

				// Klaviyo Setup Code ***********************

				checked_AllInputs.forEach( function( checked_SingleInput )
				{
					var question_tab = quetion_area.getAttribute( "data-question_tab" );
					if( question_tab == 'question_tab_1' )
					{
						select_collections.push(checked_SingleInput.value);
					}

					if( question_tab == 'question_tab_2' )
					{
						select_type.push(checked_SingleInput.value);
					}

					if( question_tab == 'question_tab_3' )
					{
						select_vendor.push(checked_SingleInput.value);
					}
				});		
				document.querySelector('.welleasy_email_area input[name="Selected_Diet"]').value = JSON.stringify(select_collections);
				document.querySelector('.welleasy_email_area input[name="Selected_Aisles"]').value = JSON.stringify(select_type);
				document.querySelector('.welleasy_email_area input[name="Selected_Brands"]').value = JSON.stringify(select_vendor);

				var redirecturl =  document.querySelector('.welleasy_email_area input[name="Result_Url"]').getAttribute( "href" );
				//if(select_vendor.length > 0)
                if( nextButton.dataset.next_step == "welleasy_email_section" )
				{
			
					KlaviyoSubscribe.attachToForms('#email_signup', 
					{
						hide_form_on_success: true,
						success_url: redirecturl,
						extra_properties: {
							$source: 'Quiz Result Form',
						}
					});
				}


			// Mobile animation
			if (window.innerWidth <= 1024) 
			{
				var welleasy_step_numbers = document.querySelector(".welleasy_step_numbers");
				welleasy_step_numbers.classList.add('background_step_'+nextButton.dataset.next_step_number);
				
			}
        });
    });
}

function activeinput() 
{
	var allinput = document.querySelectorAll(".single_option input");
	var lifestyle = document.querySelector(".welleasy_quiz_questions");
	allinput.forEach((input) =>
	{	
		input.addEventListener("change", function(e)
		{
			if(lifestyle.contains(input) && !lifestyle.querySelector("input[first-choice='true']"))
			{
				input.setAttribute("first-choice",true);
			}
            input.parentNode.classList.toggle('active');
		});
	});
}

function quantity() 
{
	var qtyBox = document.querySelector("#question_qty");
	var plusBtn = document.querySelector(".plus");
	var minusBtn = document.querySelector(".minus");
	if(plusBtn)
	{
		plusBtn.addEventListener("click", function(e) 
		{
			qtyBox.value = parseInt(qtyBox.value) + 1;
		});
	}

	minusBtn.addEventListener("click", function(e) 
	{
		if (qtyBox.value > 1) 
		{
			qtyBox.value = parseInt(qtyBox.value) - 1;
		}
	});
}

function HandleShowWEQuizResultsBtnClick()
{
	$( '.we-results-continue' ).on( "click", function( e )
	{
		e.preventDefault();
		HandleWEQuizAnswers();
	} );
}

function HandleWEQuizAnswers()
{
	var redirectURL = GetWEQuizRedirectURL();
	window.location.href = redirectURL;
}

function GetWEQuizRedirectURL()
{
	var url = "/pages/welleasy-quiz-product";

	var questionSections = document.querySelectorAll( ".question_options" );
	var saving_price	= document.querySelector( ".question_qty_box" ).value;
	var aisles_titles	= "";
	questionSections.forEach( function( section )
	{
		var type 			= section.getAttribute( "data-type" );
		var query 			= encodeURIComponent( type ) + "=";
		var answerInputs	= section.querySelectorAll( ".single_option input[type='checkbox']:checked" );

		var foodAisles		= "&foodAisles=";
		var nonFoodAisles	= "&nonFoodAisles=";

		var answersIdx 	= 1;
		var component 	= "";
		
		answerInputs.forEach( function( answer )
		{

			// console.log(answer)
			// console.log(answer.getAttribute("first-choice"))
			component 		= component + answer.value;

			if(answer.getAttribute("first-choice") == "true")
			{
				// console.log("///////////////////")
				component = component + "_FC"	
			}
			
			// console.log(component)

			if( answersIdx != answerInputs.length )
			{
				component = component + ",";
			}
			answersIdx = answersIdx + 1;



			if( type == "aisles" )
			{

			
				// preparing titles
				var aisles_single_title = answer.getAttribute( "data-aisles_titles" )
				if (aisles_single_title.includes( '_' )) 
				{
					const lastIndex = aisles_single_title.lastIndexOf('_');
					aisles_single_title = aisles_single_title.slice(0, lastIndex) + ' & ' + aisles_single_title.slice(lastIndex + 1);
					aisles_single_title = aisles_single_title.replaceAll("_", ", ");
				}
				if( aisles_titles == "" )
				{
					aisles_titles = aisles_titles + aisles_single_title;
				}
				else
				{
					aisles_titles = aisles_titles + '_' + aisles_single_title;
				}

			}

			if( type == "aisles" && answer.getAttribute( "data-food-collection" ) == "true" )
			{
				if( foodAisles == "&foodAisles=" )
				{
					foodAisles = foodAisles + answer.value;
				}
				else
				{
					foodAisles = foodAisles + "," + answer.value;
				}

			}
			else if( type == "aisles" && answer.getAttribute( "data-food-collection" ) == "false" )
			{
				if( nonFoodAisles == "&nonFoodAisles=" )
				{
					nonFoodAisles = nonFoodAisles + answer.value;
				}
				else
				{
					nonFoodAisles = nonFoodAisles + "," + answer.value;
				}
			}

		} ); 

		query = query + encodeURIComponent( component );

		if( foodAisles != "&foodAisles=" )
		{
			query 		= query + encodeURIComponent( foodAisles );
		}

		if( nonFoodAisles != "&nonFoodAisles=" )
		{
			query 		= query + encodeURIComponent( nonFoodAisles );
		}

		if( url.includes( "?" ) )
		{
			url = url + "&" + query;
		}
		else
		{
			url = url + "?" + query;
		}
		
	} );

	if (url.includes('saving_price') == false) 
	{
		if (saving_price) 
		{
			url = url + "&saving_price=" + encodeURIComponent(saving_price);
		}
	}


	document.querySelector('.welleasy_email_area input[name="Result_Url"]').setAttribute( "href", url );
	document.querySelector('.welleasy_email_area input[name="Result_Url"]').setAttribute( "value", 'https://welleasy.co.uk' + url );

	return url;
}

function validateEmail()
{


    var input = document.querySelector( ".quiz_email" );
    var error_message = document.querySelector( ".error_message" );
    var email_button = document.querySelector( ".email_button" );
    var welleasy_skip_email  = document.querySelector( ".welleasy_skip_email " );
	
	if ( email_button )
	{		
		email_button.addEventListener( "click", function(e)
		{
			
			var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	
			if ( input.value.match(validRegex) )
			{
				error_message.innerText = ""
				input.classList.remove( "error" );
				
				// document.form1.text1.focus();
				return true;
			}
			else
			{
				error_message.innerText = "Please enter a valid email address.";
				input.classList.add( "error" );
				// document.form1.text1.focus();
				return false;
			}
		});
		
	}
	if( input )
	{
		input.addEventListener("input", () => 
		{
			if ( input.value.trim() !== "" ) 
			{
				welleasy_skip_email.style.display = "none";
			} else 
			{
				welleasy_skip_email.style.display = "block";
			}
		});
	}

		
		


	
}

window.addEventListener( "DOMContentLoaded", function(e)
{
    initStepsAnimation();
	activeinput();
	var plusBtn = document.querySelector( ".plus" );
	if( plusBtn )
	{
		quantity();
	}
	HandleShowWEQuizResultsBtnClick();
	validateEmail();
});